var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form" }, [
    _c(
      "div",
      { staticClass: "form-row" },
      [
        _c("input-text", {
          ref: "coprNmad",
          attrs: {
            id: "coprNmad",
            value: _vm.data.coprNmad,
            "label-i18n": "MCOP-01-01-04-06",
            placeholder: "MCOP-01-01-04-06",
            maxlength: 10,
            "err-msg-param": { filed: _vm.$t("MCOP-01-01-04-06"), max: 10 },
            toLowerCase: ""
          },
          on: {
            "update:value": function($event) {
              return _vm.$set(_vm.data, "coprNmad", $event)
            }
          }
        })
      ],
      1
    ),
    _c("div", { staticClass: "form-row" }, [
      _c(
        "div",
        { staticClass: "item-tit" },
        [
          _vm._v(" " + _vm._s(/*상세 주소*/ _vm.$t("MCOP-01-01-04-07")) + " "),
          _c("required")
        ],
        1
      ),
      _c("div", { staticClass: "item-desc" }, [
        _c("div", { staticClass: "form-text-field" }, [
          _c(
            "div",
            { staticClass: "input-text-field address" },
            [
              _c("input-text", {
                ref: "coprAddr1",
                attrs: {
                  id: "coprAddr1",
                  value: _vm.data.coprAddr1,
                  placeholder: "MCOP-01-01-04-07",
                  maxlength: 66,
                  "err-msg-param": {
                    filed: _vm.$t("MCOP-01-01-04-07"),
                    max: 66
                  },
                  required:
                    _vm.$config.SITECODE_OGCBD +
                    "|" +
                    _vm.$config.SITECODE_OGHCM +
                    "|" +
                    _vm.$config.SITECODE_OGMMR,
                  toLowerCase: ""
                },
                on: {
                  "update:value": function($event) {
                    return _vm.$set(_vm.data, "coprAddr1", $event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "input-text-field" },
            [
              _c("input-text", {
                ref: "coprAddr2",
                attrs: {
                  id: "coprAddr2",
                  value: _vm.data.coprAddr2,
                  maxlength: 66,
                  "err-msg-param": {
                    filed: _vm.$t("MCOP-01-01-04-07"),
                    max: 66
                  },
                  toLowerCase: ""
                },
                on: {
                  "update:value": function($event) {
                    return _vm.$set(_vm.data, "coprAddr2", $event)
                  }
                }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _c(
      "div",
      { staticClass: "form-row" },
      [
        _c("input-text", {
          ref: "coprAddr3",
          attrs: {
            id: "coprAddr3",
            value: _vm.data.coprAddr3,
            "label-i18n": "MCOP-01-01-04-08",
            placeholder: "MCOP-01-01-04-08",
            toLowerCase: ""
          },
          on: {
            "update:value": function($event) {
              return _vm.$set(_vm.data, "coprAddr3", $event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }